"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetProgressOvertime = exports.useGetNeedResponsesCount = exports.useEditBulkObjectives = exports.useGetTotalObjectives = exports.useGetObjectives = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_query_1 = require("react-query");
const ObjectivesClient_1 = require("client/ObjectivesClient");
const objectivesKeys_1 = __importDefault(require("consts/queryKeys/objectivesKeys"));
const useGetObjectives = (page, params, options) => {
    const fetchObjectives = (olderThan, signal) => {
        return (0, ObjectivesClient_1.getListObjectives)(Object.assign(Object.assign({}, params), { olderThan }), signal);
    };
    return (0, react_query_1.useInfiniteQuery)(objectivesKeys_1.default.objectives(page, params), ({ pageParam, signal }) => fetchObjectives(pageParam, signal), Object.assign({ getNextPageParam: (lastPage) => {
            var _a, _b;
            return (_b = (_a = lastPage === null || lastPage === void 0 ? void 0 : lastPage.pagination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 ? void 0 : _b.olderThan;
        } }, options));
};
exports.useGetObjectives = useGetObjectives;
const useGetTotalObjectives = (params, options) => {
    const fetchTotalObjectives = (signal) => {
        return (0, ObjectivesClient_1.getTotalObjectives)(params, signal);
    };
    return (0, react_query_1.useQuery)(objectivesKeys_1.default.totalObjectives(params), ({ signal }) => fetchTotalObjectives(signal), options);
};
exports.useGetTotalObjectives = useGetTotalObjectives;
const useEditBulkObjectives = () => {
    return (0, react_query_1.useMutation)((body) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield (0, ObjectivesClient_1.updateBulkObjective)(body);
        if (response === null || response === void 0 ? void 0 : response.isSuccess) {
            return response;
        }
        throw response;
    }));
};
exports.useEditBulkObjectives = useEditBulkObjectives;
const useGetNeedResponsesCount = (type, params, options) => {
    const fetchNeedResponsesCount = () => {
        return (0, ObjectivesClient_1.getNeedResponses)(params);
    };
    return (0, react_query_1.useQuery)(objectivesKeys_1.default.needResponseCount(type, params), fetchNeedResponsesCount, options);
};
exports.useGetNeedResponsesCount = useGetNeedResponsesCount;
const useGetProgressOvertime = (id, page, params, options) => {
    const fetchProgressOvertime = (olderThan, signal) => {
        return (0, ObjectivesClient_1.getProgressOvertimeData)(id, Object.assign(Object.assign({}, params), { olderThan }), signal);
    };
    return (0, react_query_1.useInfiniteQuery)(objectivesKeys_1.default.objectives(page, params), ({ pageParam, signal }) => fetchProgressOvertime(pageParam, signal), Object.assign({ getNextPageParam: (lastPage) => {
            var _a, _b;
            return (_b = (_a = lastPage === null || lastPage === void 0 ? void 0 : lastPage.pagination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 ? void 0 : _b.olderThan;
        } }, options));
};
exports.useGetProgressOvertime = useGetProgressOvertime;
